import { ConfigValidatorFactory } from './types'

export const isRequired: ConfigValidatorFactory =
  ({ title, message }) =>
  value => {
    if (Array.isArray(value)) {
      return value.length === 0 ? { title, message } : undefined
    }

    // Trim strings so a whitespace-only value (e.g. a subject of spaces) is
    // treated as empty rather than satisfying the requirement.
    if (typeof value === 'string') {
      return value.trim().length === 0 ? { title, message } : undefined
    }

    return value ? undefined : { title, message }
  }
